(ns teamoesterreich.user-mode.event.event-briefing
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [goog.json :as json]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.map.map-polygon :as map-polygon]
    [teamoesterreich.util.markdown :refer [md]]))



(defn get-it []
  (let [!select-event (r/cursor store/app-state [:select-event])
        !forTomId (r/cursor store/app-state [:actual-events :forTomId])
        list (deref (r/cursor store/app-state [:actual-events :list]))
        d-event (reduce (fn [c e] (or c (when (= @!select-event (:crowdtaskerEvent-uuid e)) e))) nil list)]
    (println "!select-event " @!select-event (clj->js d-event))
    (if (nil? @!select-event)
      [mui/card
       [mui/card-content
        [:div "Einsatz nicht gefunden! " @!select-event]
        [:br]
        [:br]
        [mui/button
         {:variant "contained"
          :onClick #(a/set-page :landing)
          }
         "Zurück"]
        ]]

      [mui/card
       [mui/card-content
        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "center"
          :alignItems "stretch"
          :spacing    5
          :style      {:marginTop "15px"}
          }
         [mui/grid
          {:container false
           :item      true
           :xl        6
           :lg        8
           :xs        12
           }
          [:h2 "Einsatz: `" (:crowdtaskerEvent-name d-event) "` " (when (false? (:crowdtaskerEvent-published d-event)) " - NICHT VERÖFFENTLICHT")]
          ]
         (when (:_polygonJsonString d-event)
           [mui/grid
            {:container false
             :item      true
             :lg        8
             :xs        12
             :style     {:text-align "center"}
             }
            [:div {:style {:max-width "800px"}}
             [map-polygon/pick-polygon-gmap-component
              (clj->js (json/parse (:_polygonJsonString d-event)))
              ]]
            ])
         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Ort:"]
           (:_locationName d-event)]]

         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Tätigkeit:"]
           (:crowdtaskerEvent-descriptionTask d-event)]]

         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Mitzubringen:"]
           (:crowdtaskerEvent-descriptionBring d-event)]]

         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Kontakt:"]
           (:crowdtaskerEvent-descriptionContact d-event)]]
         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Treffpunkt:"]
           (:crowdtaskerEvent-descriptionPickup d-event)]]


         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           :style     {:text-align "left" :border "1px dotted "}
           }
          [mui/form-control
           [mui/form-label "Einsatz Auftrag:"]
           [:div {:style {:max-width "800px"}
                  :dangerouslySetInnerHTML
                  {:__html
                   (.render md
                            (:crowdtaskerEvent-briefing d-event))
                   }}]]]

         [mui/grid
          {:container false
           :item      true
           :lg        8
           :xs        12
           }
          [:br]
          [:br]
          [:br]
          ]
         ]
        [mui/card-actions
         {:style {:max-width "800px" :margin "0 auto 0 auto"}}
         [mui/grid
          {:container  true
           :direction  "row"
           :justify    "space-between"
           :alignItems "stretch"
           :spacing    0
           }
          [mui/grid
           {:item  true
            :xs    6
            :style {:text-align "left"}
            }

           [mui/button
            {:variant "contained"
             :onClick (fn []
                        (reset! !forTomId -1)
                        (a/set-page :landing))
             }
            "Zurück"]]

          [mui/grid
           {:item  true
            :xs    6
            :style {:text-align "right"}
            }

           (when (:_yes-no d-event)
             [mui/button
              {:style   {:width "160px" :margin "5px"}
               :variant "contained"
               :color   "primary"
               :onClick (fn []
                          (a/set-user-crowdtasker-response @!select-event
                                                           {:accept-timestamp (js/Date.)
                                                            :accept-device    "Browser"
                                                            :declined         true
                                                            })
                          (js/setTimeout #(reset! !forTomId -1) 3000)
                          (js/setTimeout #(reset! !forTomId -1) 10000)
                          (a/set-page :landing))
               }
              "Absagen"])
           ]
          ]]
        ]]
      )))
